// import api from "../../api";

const state = {
  fcjobData: {}
};

const getters = {};

const mutations = {
  addToFcJob(state, data) {
    state.fcjobData = data;
  },
  updateFcJob(state, data) {
    state.fcjobData = { ...state.fcjobData, ...data };
  }
};

const actions = {};

export const fcjob = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
